import * as THREE from "three"
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer.js"
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js"
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass"
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass"
import { TexturePass } from "three/examples/jsm/postprocessing/TexturePass.js"
import { ClearPass } from "three/examples/jsm/postprocessing/ClearPass.js"
import {
  MaskPass,
  ClearMaskPass,
} from "three/examples/jsm/postprocessing/MaskPass.js"
import { CopyShader } from "three/examples/jsm/shaders/CopyShader.js"
import { BokehPass } from "three/examples/jsm/postprocessing/BokehPass"

import {
  camera,
  postProcessingFolder,
  renderer,
  scene,
  sceneMasked,
  sizes, stencilScene,
} from "./Experience"
import {SMAAPass} from "three/examples/jsm/postprocessing/SMAAPass";

export class PostProcessing {
  constructor() {
    this.setPostProcessing()
    this.setTweaks()
  }

  setPostProcessing() {
    this.renderTarget = new THREE.WebGLRenderTarget(800, 600, {
      samples: renderer.renderer.getPixelRatio() === 1 ? 2 : 0,
      stencilBuffer: true,
    })

    this.effectComposer = new EffectComposer(
      renderer.renderer,
      this.renderTarget
    )
    this.effectComposer.setSize(sizes.width, sizes.height)
    this.effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    // let gl = renderer.renderer.getContext();
    // gl.enable(gl.STENCIL_TEST);
    // gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
    //
    // // renderer.renderer.clear();
    //
    // gl.stencilFunc(gl.ALWAYS, 1, 0xFF);
    // gl.stencilMask(0xFF);
    // this.stencilRenderPass = new RenderPass(stencilScene, camera.camera)
    // this.effectComposer.addPass(this.stencilRenderPass)
    //
    // gl.stencilFunc(gl.EQUAL, 1, 0xFF);
    // gl.stencilMask(0x00);
    //
    // scene.renderOrder = 3;
    this.renderPass = new RenderPass(scene, camera.camera)
    this.effectComposer.addPass(this.renderPass)
    // gl.stencilMask(0xFF);
    // gl.disable(gl.STENCIL_TEST);

    let smaa = new SMAAPass( window.innerWidth * renderer.renderer.getPixelRatio(), window.innerHeight * renderer.renderer.getPixelRatio() );
    // this.effectComposer.addPass(smaa)

    const pixelRatio = renderer.renderer.getPixelRatio();

    this.unrealBloomPass = new UnrealBloomPass()
    this.unrealBloomPass.strength = 0.23
    this.unrealBloomPass.radius = 0.2
    this.unrealBloomPass.threshold = 0
    // this.effectComposer.addPass(this.unrealBloomPass)

    // this.bokehPass = new BokehPass(scene, camera.camera, {

    //   focus: 1.2,
    //   aperture: 0.025,
    //   maxblur: 0.003,
    // })
    // this.effectComposer.addPass(this.bokehPass)
  }

  setTweaks() {
    postProcessingFolder.addInput(this.unrealBloomPass, "strength", {
      min: 0,
      max: 2,
      step: 0.01,
      label: "Strength",
    })

    postProcessingFolder.addInput(this.unrealBloomPass, "radius", {
      min: 0,
      max: 5,
      step: 0.01,
      label: "Radius",
    })

    postProcessingFolder.addInput(this.unrealBloomPass, "threshold", {
      min: 0,
      max: 1,
      step: 0.01,
      label: "Threshold",
    })

    // postProcessingFolder.addInput(this.bokehPass.uniforms, "focus", {
    //   min: 0,
    //   max: 2,
    //   step: 0.01,
    // })
  }
}
